import React, { createRef, Component } from "react";
import Flicking, { FlickingError } from "@egjs/react-flicking";
import styles from "./Carousel.module.css";
import { AutoPlay } from "@egjs/flicking-plugins";

interface State {
  images: string[];
}

class MyComponent extends Component<{}, State> {
  private flicking = createRef<Flicking>();
  private _plugins = [new AutoPlay()];

  constructor(props: {}) {
    super(props);
    this.state = {
      images: [],
    };
  }

  async componentDidMount() {
    try {
      const response = await fetch(`${process.env.PUBLIC_URL}/assets/reviews/reviews.json`);
      if (!response.ok) {
        console.warn("Could not load review image list:", response.statusText);
        return;
      }
      const fileNames: string[] = await response.json();
      this.setState({
        images: fileNames.map((name) => `${process.env.PUBLIC_URL}/assets/reviews/${name}`),
      });
    } catch (error) {
      console.warn("Error loading review images:", error);
    }
  }

  render() {
    return (
      <Flicking ref={this.flicking} circular={true} plugins={this._plugins} align="center">
        {this.state.images.map((image, idx) => (
          <div className={styles.panel} key={idx}>
            <img src={image} alt={`Image ${idx + 1}`} className={styles.image} />
          </div>
        ))}
      </Flicking>
    );
  }

  async moveToNextPanel() {
    try {
      await this.flicking.current?.next();
    } catch (e) {
      if (e instanceof FlickingError) {
        console.log(e instanceof FlickingError); // true
        console.log(e.code);
      }
    }
  }
}

export default MyComponent;
